import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { orderBy } from 'lodash-es';
import Search from 'sushiweb/Icons/all/Search';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import Download from 'sushiweb/Icons/all/Download';
import { exportCSV, getCurrentDate, searchWithName } from '../../../helpers';
import DataTables from '../../common/components/DataTables/DataTables';
import { groupHeadColumn } from '../../common/components/DataTables/components/headColumns';
import {
  REFRESH_LABEL,
  applicableFlowTypes,
  currentFlowTypeEnum,
} from '../../common/components/constants';
import ErrorPage from '../../common/components/ErrorPage/ErrorPage';
import {
  SearchContainerV2,
  SearchInput,
  TableContainerWithOverflow,
} from '../../common/styles';

const GroupsTable = ({
  currentFlow,
  selectedWorkspace,
  getAllGroups,
  fetchingGroups,
  groupsData,
  fetchedGroups,
}) => {
  const keyFields = ['group_name'];
  const { groups = [] } = groupsData;
  // const employeesFetchError = !fetchingGroups && !fetchedGroups;
  const [loading, setLoading] = useState(true);
  const [currentData, setCurrentData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, onInputChange] = useState('');
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [isSearchClicked, setIsSearchClicked] = useState(false);

  useEffect(() => {
    if (selectedWorkspace && selectedWorkspace.workspace_id)
      getAllGroups({
        workspaceId: selectedWorkspace.workspace_id,
        flowType: currentFlow,
      });
  }, [selectedWorkspace, currentFlow]);

  useEffect(() => {
    if (!fetchingGroups) {
      if (groups) {
        groups.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
        setSearchResults(groups);
        setCurrentData(groups.slice(0, 10));
      }
      setLoading(false);
    }
  }, [fetchingGroups]);

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const timeout = setTimeout(() => {
      if (!fetchingGroups) {
        const arr = searchWithName(groups, search, keyFields);
        setSearchResults(arr);
        handlePageChange(1);
      }
    }, 500);

    return () => setTypingTimeout(timeout);
  }, [search, fetchingGroups]);

  useEffect(() => {
    if (searchResults) {
      const start = currentPage * 10 - 10;
      const end = currentPage * 10;
      const rangeData = searchResults.slice(start, end);
      setCurrentData(rangeData);
    }
  }, [currentPage, searchResults]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // const onRefresh = () => {
  //   handlePageChange(1);
  // };
  // const refreshPage = () => {
  //   getAllGroups();
  // };
  const handleSort = (column, sortDirection) => {
    setSearchResults(orderBy(searchResults, column.selector, sortDirection));
  };

  const exportSearchResultCSV = () => {
    const headColumns = [
      { key: 'group_name', value: 'Group Name' },
      { key: 'created_on', value: 'Created on' },
      { key: 'employees', value: 'Employees' },
      { key: 'program_name', value: 'Meal plan name' },
    ];
    const statusLabelledData = [];
    searchResults.forEach(data => {
      const labelledData = {};
      labelledData.group_name = data.group_name;
      labelledData.created_on = data.group_name;
      labelledData.employees = data.employees;
      labelledData.program_name =
        !data.can_plan_be_mapped && data.program_name !== ''
          ? data.program_name
          : ' - ';
      statusLabelledData.push(labelledData);
    });
    exportCSV(statusLabelledData, `Teams - ${getCurrentDate()}`, headColumns);
  };
  const downloadCSVStyle = {
    padding: '15px 20px 10px 0px',
    cursor: 'pointer',
  };

  return (
    <>
      <SearchContainerV2>
        <SearchInput
          leftIcon={<Search />}
          innerWidth='100%'
          value={search}
          onChange={onInputChange}
          onFocus={() => setIsSearchClicked(true)}
          onBlur={() => setIsSearchClicked(false)}
          label={
            isSearchClicked ? (
              'Search by team name'
            ) : (
              <span style={{ fontSize: '16px', fontWeight: 300 }}>
                {' '}
                Search by team name{' '}
              </span>
            )
          }
        />
        <Tooltip
          position='top'
          label='Download the teams list'
          appearance='light'
          size='big'
          style={{
            fontSize: '12px',
            opacity: 0.8,
            marginRight: '10px',
            marginLeft: '-30px',
            padding: '10px',
          }}
        >
          <Download
            color='grey'
            onClick={exportSearchResultCSV}
            style={downloadCSVStyle}
          />
        </Tooltip>
      </SearchContainerV2>
      <TableContainerWithOverflow>
        {!fetchedGroups ? (
          <ErrorPage
            showAction
            actionLabel={REFRESH_LABEL}
            // clickAction={refreshPage}
          />
        ) : (
          <DataTables
            columns={groupHeadColumn}
            loading={fetchingGroups || loading}
            data={currentData}
            pagination
            totalRows={searchResults.length}
            handlePageChange={handlePageChange}
            onSort={handleSort}
            emptyStateTitle='No teams'
          />
        )}
      </TableContainerWithOverflow>
    </>
  );
};

GroupsTable.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  groupsData: PropTypes.objectOf(PropTypes.any),
  getAllGroups: PropTypes.func,
  fetchingGroups: PropTypes.bool,
  fetchedGroups: PropTypes.bool,
};

GroupsTable.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  selectedWorkspace: {},
  groupsData: {},
  getAllGroups: _noop,
  fetchingGroups: true,
  fetchedGroups: true,
};

export default GroupsTable;
